import { PROYECT } from "services/api";
import { reportDepositsTypes } from "redux/reducers/Reports/reportDeposits/types";
import { saveAs } from 'file-saver';
import axios from "axios";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { getErrorBlob } from "helpers/extractError";
const { SET_REPORT_DEPOSITS_FILTERS } = reportDepositsTypes


export const getReportDepositsAction = ({ startDate, endDate, station, isPdf = true }) => {
  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user');
    const auth = { headers: { authorization: token } };
    const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/deposits/report/${station.id}?start=${startDate}&end=${endDate}&pdf=${isPdf}`;
    const fileName = `Reporte_Depósitos_${station.name}_${startDate}_${endDate}.${isPdf ? 'pdf' : 'xlsx'}`;

    dispatch(startRequestComp('loadingReportDeposits'))
    const access = {
      url: reportUrl,
      method: 'GET',
      responseType: 'blob',
      ...auth
    }
    try {
      const file = await axios(access)
      saveAs(file.data, fileName)
      dispatch(setSnackbar(`${isPdf ? 'PDF' : 'Excel'} Descargado con éxito`, "success"))
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)))
    } finally {
      dispatch(stopRequestComp('loadingReportDeposits'))
    }
  }
}

export const setReportDepositsFilters = (key = "", value) => {
  return {
    type: SET_REPORT_DEPOSITS_FILTERS,
    payload: { value, key }
  }
}
